import { Form, FormProps, Menu, MenuProps } from "antd";
import { FC, useEffect } from "react";
import PaymentStatus from "../../types/paymentStatus.type";

export type FilterPaymentStatus = PaymentStatus | "ALL";

interface IProps extends Omit<FormProps, "defaultValue"> {
  defaultValue?: FilterPaymentStatus | boolean | string;
}

export const StatusFilter: FC<IProps> = ({ defaultValue: defaultValueProp, ...formProps }) => {
  const FILTER_ITEMS: MenuProps["items"] = [
    {
      label: "All Providers",
      key: "false",
    },
    {
      label: "Default Provider",
      key: "true",
    },
  ];

  // Convert defaultValue to string key for menu selection
  const getSelectedKey = () => {
    if (defaultValueProp === undefined || defaultValueProp === null) {
      return "false";
    }
    // Handle boolean, string "true"/"false", or actual true/false
    const value = defaultValueProp === true || defaultValueProp === "true";
    return value ? "true" : "false";
  };

  const selectedKey = getSelectedKey();

  // Set initial form value based on defaultValue
  useEffect(() => {
    if (formProps?.form && defaultValueProp !== undefined) {
      const formValue = defaultValueProp === true || defaultValueProp === "true" ? "true" : "false";
      formProps.form.setFieldValue("isDefault", formValue);
    }
  }, [defaultValueProp, formProps?.form]);

  const changeFilterStatus: MenuProps["onClick"] = (item) => {
    formProps?.form?.setFieldValue("isDefault", item.key);
    formProps?.form?.submit();
  };

  return (
    <>
      <Menu
        onClick={changeFilterStatus}
        selectedKeys={[selectedKey]}
        mode="horizontal"
        items={FILTER_ITEMS}
      />
      <Form {...formProps} hidden>
        <Form.Item name="isDefault" />
      </Form>
    </>
  );
};
